var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16082",
    "data-name": "Group 16082",
    transform: "translate(395 -3280)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(-395 3280)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 76,
    cy: 76,
    r: 76,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_67_-_Outline",
    "data-name": "Ellipse 67 - Outline",
    d: "M76,4.75A71.25,71.25,0,0,0,25.619,126.381,71.25,71.25,0,1,0,126.381,25.619,70.783,70.783,0,0,0,76,4.75M76,0A76,76,0,1,1,0,76,76,76,0,0,1,76,0Z",
    fill: "#ffd055"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M25.756,48.266,57.6,16.445a6.015,6.015,0,0,0-8.519-8.494L13,44.007a6,6,0,0,0-.175,8.294L49.058,88.606a6.015,6.015,0,1,0,8.519-8.494Z",
    transform: "translate(-359.06 3307.723)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconBack);
export default __webpack_public_path__ + "static/media/general-icon-back.2f191d941d15ed57766bd233a9ba01ec.svg";
export { ForwardRef as ReactComponent };